import { ACTIONS } from '@~/actions/chat-window';

const inititalState = {
  groupChatToggleState: null,
};

export default function defaultExport(state = null, { type, payload }) {
  const { key, value } = payload || {};

  switch (type) {
    case ACTIONS.TOGGLED_GROUP_CHAT: {
      localStorage.setItem(`${key}:group-chat-toggled-state`, value);

      return {
        groupChatToggleState: value,
      };
    }
    case ACTIONS.RESET_GROUP_CHAT:
      return inititalState;

    default:
      return state;
  }
}
